import * as React from 'react';
import { useCallback, useMemo } from 'react'
import Box from '@mui/material/Box';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useDropzone } from 'react-dropzone'

const baseStyle = {
    padding: '20px',
    border: '4px dashed',
    borderColor: 'grey',
    borderRadius: '10px',
    textAlign: 'center'
}

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    opacity: '30%',
    borderColor: '#ff1744'
};

export default function DropZoneArea(props) {
    const onDrop = useCallback((arg) => props.onDrop(arg), [props]);

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({ onDrop, ...props.accept });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <Box {...getRootProps({ style })}>
            <CloudUploadIcon />
            <input {...getInputProps()} />
            <p>{props.message}</p>
        </Box>
    );
}